'use client';

import { OrderHistory } from 'components/ui/organisms';
import { useOrders } from 'frontastic/hooks';
import { TasticProps } from '../types';
import { OrderHistoryDataSource } from './types';

export const OrderHistoryTastic = () => {
  const ordersResponse = useOrders();

  return <OrderHistory {...ordersResponse} />;
};

export const DynamicOrderHistoryTastic = ({
  data,
}: TasticProps<OrderHistoryDataSource>) => {
  // Added for dynamic page handler performance testing
  console.info(data.orders.dataSource);

  return <div>dynamic order history</div>;
};
